module.exports = __webpack_public_path__ + "static/img/3.28b9f4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/eng/3.png
// module id = 4T3A
// module chunks = 0